import { Button, MagellanPopup } from "components/atoms";
import { format } from "date-fns";
import { pl } from "date-fns/locale";
import {} from "i18next";
import { ComponentType, ReactNode, useRef } from "react";
import { EventProps, ShowMoreProps } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { TbCalendar, TbX } from "react-icons/tb";
import Popup from "reactjs-popup";
import { PopupActions } from "reactjs-popup/dist/types";
import "./CalendarShowMore.scss";

interface ICalendarShowMore<TEvent extends object>
  extends ShowMoreProps<TEvent> {
  eventComponent?: ComponentType<EventProps<TEvent>> | undefined;
  moreHeader?: ReactNode;
}

const CalendarShowMore = <TEvent extends object>({
  localizer,
  slot,
  slotDate,
  count,
  events,
  remainingEvents,
  eventComponent,
  moreHeader,
}: ICalendarShowMore<TEvent>) => {
  const ref = useRef<PopupActions>(null);
  const { t } = useTranslation();

  const Event = eventComponent;
  return (
    <Popup
      ref={ref}
      onOpen={(e) => e?.preventDefault()}
      modal
      nested
      trigger={
        <Button
          size="compact"
          className="rbc-show-more"
          isClear
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {t("button.plus-count-more", { count: count })}
        </Button>
      }
    >
      {" "}
      <MagellanPopup>
        <MagellanPopup.Header className="justify-center w-80 mb-5">
          <TbCalendar />
          {format(slotDate, "dd.MM.yyyy", { locale: pl })} ({events.length})
        </MagellanPopup.Header>
        <div className="flex flex-col w-full gap-6 my-6 max-w-[400px]">
          {events.map(
            (e) =>
              Event && (
                <Event
                  event={e}
                  title=""
                  continuesPrior={true}
                  continuesAfter={true}
                  localizer={localizer}
                  slotStart={new Date()}
                  slotEnd={new Date()}
                />
              )
          )}
        </div>
        <MagellanPopup.BottomButtons>
          <Button onClick={() => ref.current?.close()} isClear fullWidth>
            <TbX /> {t("button.cancel")}
          </Button>
        </MagellanPopup.BottomButtons>
      </MagellanPopup>
    </Popup>
  );
};

export default CalendarShowMore;
